"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPickDate = CustomPickDate;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Button = _interopRequireDefault(require("../../Button"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../utils/constants");
var _classnames = _interopRequireDefault(require("classnames"));
var _time = require("../../../utils/time");
var _ = _interopRequireWildcard(require("../"));
var _DatePick = require("./DatePick");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFALUT_TEXT = 'Date';
function getShowTimeRange(active, rangeTimeType) {
  if (active) {
    return {
      start: 0,
      end: 0
    };
  }
  var rangeTime = (0, _time.getTimeRangeBymoment)()[rangeTimeType];
  var startTimeStamp = rangeTime.startTimeStamp,
    endTimeStamp = rangeTime.endTimeStamp;
  return {
    start: startTimeStamp,
    end: endTimeStamp
  };
}
function getShowCustomTimeRangeText(start, end) {
  if (!end) {
    return "From ".concat(start);
  } else if (!start) {
    return "Until ".concat(end);
  } else {
    return "".concat(start, " to ").concat(end);
  }
}
function getTimeStamp(active, start, end) {
  return {
    start: !active ? start : 0,
    end: !active ? end : 0
  };
}
function getTimeValueOf(start, end) {
  if (!start && !end) {
    return {
      startTime: 0,
      endTime: 0
    };
  }
  if (!start) {
    return {
      startTime: 0,
      endTime: (0, _moment["default"])(end).valueOf()
    };
  }
  return {
    startTime: (0, _moment["default"])(start).valueOf(),
    endTime: start === end ? (0, _moment["default"])(start).valueOf() + _constants.ONE_DAY_SECONDS - 1 : (0, _moment["default"])(end).valueOf()
  };
}
function DatePickTitle(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement("h5", {
    className: "text-dark mb-2 mt-2"
  }, children);
}
function CustomPickDate(props) {
  var onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    time = props.time;
  var _useState = (0, _react.useState)(time),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    pickTime = _useState2[0],
    setPickTime = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isErrorTime = _useState4[0],
    setIsErrorTime = _useState4[1];
  var disabled = !pickTime.start.valueOf() && !pickTime.end.valueOf() || isErrorTime;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 mt-4 w-full"
  }, /*#__PURE__*/_react["default"].createElement(DatePickTitle, null, "From"), /*#__PURE__*/_react["default"].createElement(_DatePick.DatePick, {
    format: "MM/DD/YY",
    value: pickTime.start,
    maxDate: pickTime.end.valueOf() ? pickTime.end : undefined,
    disableFuture: true,
    name: "from",
    onChange: function onChange(value) {
      if (isNaN(value)) {
        setIsErrorTime(true);
        return;
      }
      setIsErrorTime(false);
      setPickTime(_objectSpread(_objectSpread({}, pickTime), {}, {
        start: _moment["default"].unix(value)
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(DatePickTitle, null, "To"), /*#__PURE__*/_react["default"].createElement(_DatePick.DatePick, {
    format: "MM/DD/YY",
    value: pickTime.end,
    disableFuture: true,
    minDate: pickTime.start.valueOf() ? pickTime.start : undefined,
    name: "to",
    onChange: function onChange(value) {
      if (isNaN(value)) {
        setIsErrorTime(true);
        return;
      }
      setIsErrorTime(false);
      setPickTime(_objectSpread(_objectSpread({}, pickTime), {}, {
        end: _moment["default"].unix(value)
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mt-8 mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: onCancel,
    className: "w-32 !py-3 mr-4"
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: disabled,
    color: "primary",
    className: "w-32 !py-3",
    onClick: function onClick() {
      var startFormat = pickTime.start.valueOf() ? (0, _moment["default"])(pickTime.start).format('M/D/YY') : '';
      var endFormat = pickTime.end.valueOf() ? (0, _moment["default"])(pickTime.end).format('M/D/YY') : '';
      onConfirm(startFormat, endFormat);
    }
  }, "Apply")));
}
function DatePill(props, ref) {
  var onSelect = props.onSelect;
  var _useState5 = (0, _react.useState)(DEFALUT_TEXT),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    showText = _useState6[0],
    setShowText = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    pickTimeRangeType = _useState8[0],
    setPickTimeRangeType = _useState8[1];
  var _useState9 = (0, _react.useState)({
      start: 0,
      end: 0
    }),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    timeStamp = _useState10[0],
    setTimeStamp = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    showCustom = _useState12[0],
    setShowCustom = _useState12[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setTimeStamp({
          start: 0,
          end: 0
        });
        setShowText(DEFALUT_TEXT);
        setPickTimeRangeType('');
      }
    };
  });
  var customInitalTime = (0, _react.useMemo)(function () {
    return pickTimeRangeType === _constants.TimeRangeType.Custom ? {
      start: timeStamp.start,
      end: timeStamp.end
    } : {
      start: 0,
      end: 0
    };
  }, [pickTimeRangeType, timeStamp]);
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    onClose: function onClose() {
      setShowCustom(false);
    },
    isActive: !!timeStamp.start || !!timeStamp.end,
    showText: showText,
    defalutText: DEFALUT_TEXT
  }, function (_ref) {
    var handleOnToggle = _ref.handleOnToggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-72 text-dark text-lg"
    }, !showCustom && Object.keys(_constants.dateTextMapTimeRange).map(function (timeRangeType) {
      var active = pickTimeRangeType === timeRangeType && timeRangeType !== _constants.TimeRangeType.Custom || timeRangeType === _constants.TimeRangeType.ANY && !pickTimeRangeType;
      return /*#__PURE__*/_react["default"].createElement(_.PillItem, {
        className: (0, _classnames["default"])('last:border-t-2 last:mt-4', {
          'text-primary': timeRangeType === _constants.TimeRangeType.Custom && pickTimeRangeType === _constants.TimeRangeType.Custom
        }),
        active: active,
        text: _constants.dateTypeMapText[timeRangeType],
        onClick: function onClick() {
          if (timeRangeType === _constants.TimeRangeType.Custom) {
            setShowCustom(true);
          } else if (timeRangeType === _constants.TimeRangeType.ANY) {
            setShowText(DEFALUT_TEXT);
            onSelect(0, 0);
            setTimeStamp({
              start: 0,
              end: 0
            });
            setPickTimeRangeType(!active ? timeRangeType : '');
            handleOnToggle();
          } else {
            var rangeTimeType = _constants.dateTextMapTimeRange[timeRangeType];
            var _getShowTimeRange = getShowTimeRange(active, rangeTimeType),
              start = _getShowTimeRange.start,
              end = _getShowTimeRange.end;
            var text = _constants.dateTypeMapText[timeRangeType];
            setShowText(!active ? text : DEFALUT_TEXT);
            setTimeStamp(getTimeStamp(active, start, end));
            onSelect(start, end);
            setPickTimeRangeType(!active ? timeRangeType : '');
            handleOnToggle();
          }
        }
      });
    }), showCustom && /*#__PURE__*/_react["default"].createElement(CustomPickDate, {
      time: customInitalTime,
      onCancel: function onCancel() {
        setShowCustom(false);
      },
      onConfirm: function onConfirm(start, end) {
        var _getTimeValueOf = getTimeValueOf(start, end),
          startTime = _getTimeValueOf.startTime,
          endTime = _getTimeValueOf.endTime;
        setShowText(getShowCustomTimeRangeText(start, end));
        setTimeStamp({
          start: startTime,
          end: endTime
        });
        setPickTimeRangeType(_constants.TimeRangeType.Custom);
        onSelect(startTime, endTime);
        handleOnToggle();
        setShowCustom(false);
      }
    }));
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(DatePill);
//# sourceMappingURL=index.js.map